module.exports = __webpack_public_path__ + "assets/img/kv-e48310be.jpg";